import { createGlobalStyle } from 'styled-components';
import colors from 'styles/colors';
import fonts from 'styles/fonts';

const GlobalStyles = createGlobalStyle`
/**
* Reset
*/
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

html {
  overflow-x: hidden;
  overflow-y: auto;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

ul {
  list-style: none;
}

li {
  list-style-type: none;
}

*,
*:after,
*:before {
  box-sizing: border-box;
}
/**
* End of reset
*/

/**
* App Global Style
 */
html {
  font-size: calc(100vw / 1920 * 10);
  line-height: 1;
}

body {
  font-family: ${fonts.primary.regular};
  color:${colors.secondary.deepCove};
  min-height: 100vh;
}


a {
  color: inherit;
  outline: none;
  text-decoration: none;
}

button {
  background: unset;
  border: none;
  cursor: pointer;
  margin: 0;
  padding: 0;
}
`;

export default GlobalStyles;
